import { useAtomValue } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import { useEffect } from "react";
import {
  DEFAULT_LOCALE,
  LOCALE_EN_GB,
  LOCALE_EN_US,
} from "../../constants/constants";
import { localeAtom } from "../../store";
import type { Locale } from "../../types";

export function useLocale(defaultLocale: Locale = DEFAULT_LOCALE) {
  useHydrateAtoms([[localeAtom, defaultLocale]]);

  useEffect(() => {
    document.documentElement.lang = defaultLocale;
  }, [defaultLocale]);

  const locale = useAtomValue(localeAtom);
  const isUK = locale === LOCALE_EN_GB;
  const isUS = locale === LOCALE_EN_US;
  const dateFormat = isUK ? "dd/mm/yyyy" : "mm/dd/yyyy";

  return {
    locale,
    isUK,
    isUS,
    dateFormat,
  };
}
